import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { PROJECTS } from "../../Constants";
import CarouselImage from "./CarouselImage";

function ProjectCarousel() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  return (
    <Carousel activeIndex={index} onSelect={handleSelect}>
      {PROJECTS.map((project) => (
        <Carousel.Item id={project.id}>
          <CarouselImage src={project.image} alt={project.id} />
          <Carousel.Caption>
            <h3>{project.name}</h3>
            <p className="project-tech">{project.technologyUsed}</p>
            <p className="project-desc">{project.description}</p>
            <div class="read-more-container">
              <div class="line"></div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={project.url}
                class="read-more"
              >
                Read more <span class="icon">🔗</span>
              </a>
              <div class="line"></div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default ProjectCarousel;
